import _ from 'lodash';
import publicUrls from '../../config/publicUrls.json';
import getArticleLink from '../../util/getArticleLink';
import getCroppingQueryParams from '../../util/getCroppingQueryParams';
import React from 'react';
import Helmet from 'react-helmet';

function removeLineBreaks(string) {
  return string.replace(/(\r\n|\n|\r)/gm, ' ');
}

export default class ArticlePageMeta extends React.PureComponent {
  render() {
    const {dataSources, host, path, country} = this.props;
    const meta = {};

    let article;

    if (dataSources.article) article = dataSources.article[0];
    else if (dataSources.relatedArticles) article = dataSources.relatedArticles[0];

    if (article) {
      const url = getArticleLink(article, { href: true });
      meta.link = [{
        rel: 'canonical',
        href: url,
      }];
      meta.title = article.title;
      meta.meta = [{
        name: 'og:title',
        content: article.title,
      }, {
        name: 'og:type',
        content: 'article',
      }, {
        name: 'twitter:card',
        content: 'summary_large_image',
      }, {
        name: 'og:url',
        content: url,
      }];

      if (article.preamble) {
        meta.meta = meta.meta.concat([{
          name: 'description',
          content: removeLineBreaks(article.preamble),
        }, {
          name: 'og:description',
          content: removeLineBreaks(article.preamble),
        }]);
      }

      const image = _.get(article, 'pictures[0].data.url')
                  || _.get(article, 'videos[0].data.posterUrl');

      if (image) {
        meta.meta.push({
          name: 'og:image',
          content: image + getCroppingQueryParams(4),
        });
      }
    }

    if (host && path) {
      const protocol = host.split('://')[0];
      const domain = publicUrls[country];
      meta.url = `${protocol}://${domain}${path}`;
    }

    return (
      <Helmet {...meta} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/ArticlePageMeta.jsx